// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { ApiParameter, get } from "@insite/client-framework/Services/ApiService";

const accountInquiryUrl = "/api/wes/AccountInquiry/GetStatementSummary";

export interface InvoiceHistoryApiParameter extends ApiParameter {
    customerNumber?: string;
}

export interface StatementSummary {
    arTotal?: string;
    asOfDate?: string;
    availableCredit?: string;
    creditLimit?: string;
    current?: string;
    future?: string;
    lastPayment?: string;
    lastPurchase?: string;
    mtdPurchases?: string;
    newBalance?: string;
    ninety?: string;
    oneTwenty?: string;
    payment?: string;
    paymentDays?: string;
    previousBalance?: string;
    purchase?: string;
    sixty?: string;
    terms?: string;
    thirty?: string;
    ytdPurchases?: string;
}

export function getStatementSummary() {
    return get<StatementSummary>(accountInquiryUrl);
}
